module.exports = __webpack_public_path__ + "static/media/pic_yaoxing.da093f14.png";